var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function($event){return _vm.addFav(_vm.match)}}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isFavorite),expression:"!isFavorite"}],staticClass:"fa fa-star-o"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFavorite),expression:"isFavorite"}],staticClass:"fa fa-star"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a4e03e6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sportsbook/favButton.vue
// module id = IYaJ
// module chunks = 0